module.exports = __webpack_public_path__ + "img/architecture-buildings-city-1769371.26cee427.jpg";